module.exports = __webpack_public_path__ + "images/category_lp/macbook/store_images/1@2x_9489b4fc79fa6f129836b004b6ea9638.png";